export default {
    'success.created': 'created successfully!',
    'success.updated': 'updated successfully!',
    'success.saved': 'Saved successfully!',
    'success.sold': 'Sold successfully!',
    'success.sold1': 'Sold successfully with iosa serial:',
    'success.assigned': 'Agent reassigned successfully!',
    'success.templates': 'Templates updated successfully!',
    'success.gpsAccept': 'Action was successfully accomplished!',
    'success.gpsCanceled': 'Action was canceled!',
    'success.continue': 'You can always continue manually',
    'success.agenciesTemplate': 'Agencies successfully updated!',
    'success.cancelPolicy': 'Policy canceled successfully!',
    'loading.accountDetails': 'Loading account details...',
};
